import React, { useState, forwardRef, useEffect } from "react";

import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import MenuItem from '@mui/material/MenuItem';

import { DataGrid, GridActionsCellItem} from '@mui/x-data-grid';

import Button from "components/CustomButtons/Button.js";
import GridItem from "components/Grid/GridItem.js";
import Loader from "components/Loader/Loader";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

import moment from "moment";
import "moment/locale/es";

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

moment.locale("es");

export default function Audios() {
  
  const useStyles = makeStyles(theme => ({
    ...dashboardStyle,
    cardTitle: {
      marginTop: "0",
      minHeight: "auto",
      fontWeight: "300",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      marginBottom: "3px",
      textDecoration: "none"
    },
    select: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      color: "#D2D2D2",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "1.42857",
      letterSpacing: "unset",
      "&:before": {
        borderColor: "#D2D2D2",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "1.42857",
        letterSpacing: "unset"
      },
      "&:after": {
        borderColor: "#D2D2D2",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "1.42857",
        letterSpacing: "unset"
      }
    },
    container: {
      textAlign: "center"
    },
    content: {
      display: "inline-flex",
      padding: "10px",
      alignItems: "center"
    },
    paddingBottomCard: {
      paddingBottom: "40px"
    },
    marginRight: {
      marginRight: "10px"
    },
    marginBottom: {
      marginBottom: "50px"
    },
    formControl: {
      marginTop: theme.spacing(3.5),
      minWidth: "100%"
    },
    formControl2: {
      minWidth: "100%",
      marginTop: theme.spacing(5)
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    }
  }));

  const classes = useStyles();

  const [selectFechaInicio, setSelectedFechaInicio] = useState(new Date());
  const [selectFechaFin, setSelectedFechaFin] = useState(new Date());

  const [IdEstatus, setIdEstatus] = useState("1");
  const [Estatus, setEstatus] = useState([]);

  const [load, setLoad] = useState(false);

  const [color, setColor] = useState("");
  const [message, setMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const column = [
    { headerName: "Folio", field: "Folio", width: 250, editable: false },
    { field: 'Celular', headerName: 'Celular', width: 100, editable: false},
    { field: 'Nombre', headerName: 'Nombre', width: 250, editable: false},
    { field: 'Capturista', headerName: 'Capturista', width: 250, editable: false},
    {
        field: 'actions',
        type: 'actions',
        headerName: 'Acciones',
        width: 150,
        cellClassName: 'actions',
        getActions: ({row}) => {
          return [
              <GridActionsCellItem
                icon={<ArrowCircleDownIcon />}
                label="Editar"
                className="textPrimary"
                onClick={DescargarAudio(row)}
                color="inherit"
                key="edit"
              />
          ];
        },
      }
  ];

  const [Audios, setAudios] = useState([]);

  const DescargarAudio = (row) => () => {
    setLoad(true);
    Login()
    .then(result => {
      let token = result.token;

      DescargarArchivo(row, token)
      .then(res => res.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = row.RutaS3.split("/").pop();
        a.click();
        setLoad(false);
      });
    });
  }

  const DescargaZip = async (event) => {
    setLoad(true);
    event.preventDefault();
    const archivos = Audios.map(audio => {
      return audio.RutaS3;
    });
    Login()
    .then(result => {
        let token = result.token;

        DescargarZip(archivos, token)
        .then(res => res.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = moment().format('YYYYMMDD') + ".zip";
          a.click();
          setLoad(false);
        });
    });
  };

  const sendSnackBar = (pmessage, pcolor) => {
    setOpenSnackbar(true);
    setColor(pcolor);
    setMessage(pmessage);
  };
  
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const handeSubmit = event => {
    event.preventDefault();
    try{
        setLoad(true);

        let fechaInicio = moment(selectFechaInicio);
        fechaInicio.set({h: 0, m: 0, s: 0});

        let fechaFin = moment(selectFechaFin);
        fechaFin.set({h: 23, m: 59, s: 59});

        Login()
        .then(result => {
            if (result !== undefined) {
                let body = {
                    FechaInicio: fechaInicio.format("YYYY/MM/DD HH:mm:ss"),
                    FechaFin: fechaFin.format("YYYY/MM/DD HH:mm:ss"),
                    IdEstatus: parseInt(IdEstatus)
                };

                ObtieneArchivos(body, result.token)
                .then(result => {
                    let archivos = result.pendientes.map((element) => {
                      element.id = element.IdCaptura;

                      return element;
                    });

                    setAudios(archivos);
                    setLoad(false);
                }).catch(error => console.log(error));
            } else {
                sendSnackBar("Error de conexión", "error");
                setLoad(false);
            }
        }).catch(error => sendSnackBar("Error de conexión", "error"));
    } catch(error){
        sendSnackBar("Error de conexión", "error");
        setLoad(false);
    }
  };

  const ObtieneArchivos = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Llamadas/ObtieneArchivos",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const ObtieneEstatus = async (token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Estatus/ObtieneEstatus",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const DescargarArchivo = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        dataResponse = await fetch(
            process.env.REACT_APP_URL_APICORE + "Llamadas/DescargarArchivo" + `?key=${encodeURIComponent(data.RutaS3)}`,
            header
        );
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const DescargarZip = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        dataResponse = await fetch(
            process.env.REACT_APP_URL_APICORE + "Llamadas/DescargarZip",
            header
        );
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const Login = async () => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify({UserName: process.env.REACT_APP_USER, Password: process.env.REACT_APP_PASS}),
            headers: {
                "Content-Type": "application/json"
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Login",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  useEffect(() => {
    setLoad(true);
    Login()
    .then(result => {
      let token = result.token;

      ObtieneEstatus(token)
      .then(result => {
          setEstatus(result.estatus);
          setLoad(false);
      });
    });
  }, []);

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Grid className={classes.marginBottom}>
          <Grid container className={classes.paddingBottomCard}>
            <GridItem xs={12} sm={12} md={4}>
              <FormControl className={classes.formControl}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    format="yyyy/MM/dd"
                    label="Fecha inicio"
                    value={selectFechaInicio}
                    onChange={(date) => setSelectedFechaInicio(date)}
                    slotProps={{ textField: { fullWidth: true } }}
                    renderInput={(props) => <TextField {...props} />}
                  />
                </DemoContainer>
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <FormControl className={classes.formControl}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    label="Fecha Final"
                    format="yyyy/MM/dd"
                    value={selectFechaFin}
                    onChange={(date) => setSelectedFechaFin(date)}
                    slotProps={{ textField: { fullWidth: true } }}
                    renderInput={(props) => <TextField {...props} />}
                  />
                </DemoContainer>
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <FormControl className={classes.formControl}>
                <TextField
                  select
                  label="Estatus*"
                  value={IdEstatus} 
                  onChange={(event) => setIdEstatus(event.target.value)} 
                  style={{ width: "100%", paddingTop: "8px" }}
                >
                  {Estatus.map((option) => (
                    <MenuItem key={option.IdEstatus} value={option.IdEstatus}>
                      {option.Nombre}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>
            </GridItem>
          </Grid>
          <Grid container spacing={3} style={{marginLeft: "1px"}}>
            <GridItem xs={12} sm={12} md={2}>
              <Button
                onClick={e => {
                  handeSubmit(e);
                }}
                color="info"
              >
                Buscar
              </Button>
            </GridItem>
            <GridItem xs={12} sm={12} md={2}>
              <Button
                onClick={async (e) => {
                  await DescargaZip(e);
                }}
                color="info"
              >
                Descargar todos
              </Button>
            </GridItem>
          </Grid>
        </Grid>
      </LocalizationProvider>
        <DataGrid
            columns={column}
            rows={Audios}
            sx={{
                '& .MuiInputBase-root':
                {
                    padding: '10px 30px 10px 0 !important',
                    width: 'auto !important'
                },
                '& .MuiInputBase-root svg':
                {
                    display: 'block',
                    width: '2em',
                    height: '2em',
                    top: 'calc(50% - 1em)'
                },
            }}
            slotProps={{ pagination: { 
                labelRowsPerPage: "Registros por página",
                labelDisplayedRows: ({ from, to, count }) => `${from}–${to} de ${count !== -1 ? count : `más que ${to}`}`
                } 
            }}
        />
        <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "right" }} open={openSnackbar} onClose={handleClose} autoHideDuration={6000}>
            <Alert onClose={handleClose} severity={color} sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>
        <Loader load={load} />
    </div>
  );
}